import { TimesHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';

const GetSwimTimeRecognitionData = (swimTimeId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const swimTimeIdForUrl = swimTimeId ? encodeURIComponent(swimTimeId) : 'NaN';
    const url = `/Time/Recognition/${swimTimeIdForUrl}`;
    TimesHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData: arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetSwimTimeRecognitionData;

